import { useNavigate } from "react-router-dom";

const services = [
  {
    id: 1,
    title: "Installation & Maintenance",
    description: "Expert installation and periodic maintenance to ensure seamless machinery performance.",
    icon: "🔧",
    gradient: "from-blue-500 to-cyan-500"
  },
  {
    id: 2,
    title: "Export & Logistics Support",
    description: "Global export assistance with efficient logistics and shipping solutions.",
    icon: "🚚",
    gradient: "from-green-500 to-emerald-500"
  },
  {
    id: 3,
    title: "Spare Parts Supply",
    description: "Supplying genuine and high-quality spare parts for all major machinery brands.",
    icon: "⚙️",
    gradient: "from-orange-500 to-red-500"
  },
  {
    id: 4,
    title: "Custom Machinery Solutions",
    description: "Tailored machinery designs and solutions to meet unique industrial needs.",
    icon: "🎯",
    gradient: "from-purple-500 to-pink-500"
  },
];

const ServicesSection = () => {
const navigate = useNavigate();
const handlecontact = () => {
    navigate("/contact");
  };
  return (
    <section className="w-full bg-white py-5 px-4 sm:px-6 lg:px-8" id="services">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-gray-100 rounded-full px-6 py-2 mb-6">
            <div className="w-2 h-2 bg-[#00d9ff] rounded-full animate-pulse"></div>
            <span className="text-sm font-semibold text-[#002946]">OUR SERVICES</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-[#002946] mb-6">
            Comprehensive <span className="text-[#00d9ff]">Solutions</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            End-to-end industrial services to keep your operations running smoothly
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="group relative bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-gray-100 hover:border-transparent"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${service.gradient} rounded-2xl opacity-0 group-hover:opacity-5 transition-opacity duration-500`}></div>
              <div className="relative mb-6">
                <div className="w-16 h-16 bg-gradient-to-br from-gray-100 to-gray-200 rounded-2xl flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                  <span className="text-2xl">{service.icon}</span>
                </div>
                <div className="absolute -inset-2 bg-gradient-to-br from-gray-200 to-gray-300 rounded-2xl opacity-0 group-hover:opacity-100 blur-md transition-opacity duration-300 -z-10"></div>
              </div>
              <h3 className="text-xl font-bold text-[#002946] mb-4 group-hover:text-gray-800 transition-colors duration-300">
                {service.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                {service.description}
              </p>
              <div className="flex items-center text-[#002946] font-semibold text-sm group-hover:text-[#00d9ff] transition-colors duration-300">
              </div>
              <div className="absolute inset-0 rounded-2xl border-2 border-transparent group-hover:border-[#00d9ff]/20 transition-all duration-500"></div>
            </div>
          ))}
        </div>
        <div className="text-center mt-16">
          <div className="inline-flex flex-col sm:flex-row items-center gap-6 bg-gradient-to-r from-[#002946] to-[#004e7c] rounded-2xl p-8 text-white">
            <div className="text-left">
              <h3 className="text-2xl font-bold mb-2">Need Custom Services?</h3>
              <p className="text-blue-100">Let's discuss your specific requirements</p>
            </div>
            <button
               onClick={handlecontact} 
              className="bg-white text-[#002946] px-8 py-4 rounded-xl font-semibold hover:bg-gray-100 transition-all duration-300 transform hover:scale-105">
              Get Free Consultation
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;